import {PromocodeGroupsServiceInterface} from "@/services/PromocodeGroupsService/PromocodeGroupsService.interface";

export const PromocodeGroupsServiceSchema: PromocodeGroupsServiceInterface = {
    id: null,
    hash: null,
    type: null,
    ownerId: null,
    eventId: null,
    name: null,
    promocodesCount: null,
    isEdit: false,
    isActive: false,
}
